import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { EASE, Eyebrow, GoldButton, MaskedLine, OutlineButton } from "./Reveal";

export default function Hero() {
  const { scrollY } = useScroll();
  const yBg = useTransform(scrollY, [0, 900], [0, 200]);
  const fade = useTransform(scrollY, [0, 520], [1, 0.3]);

  return (
    <section id="top" className="relative flex min-h-[100svh] items-end overflow-hidden bg-navy-900">
      <motion.div style={{ y: yBg }} className="absolute inset-x-0 -bottom-24 -top-24 z-0">
        <img
          src="/images/hero-aerial.jpg"
          alt="Aerial view of Collanmore Island in Clew Bay, County Mayo"
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 z-10 bg-gradient-to-t from-navy-900 via-navy-900/45 to-navy-900/25" />
      <div className="absolute inset-0 z-10 bg-gradient-to-r from-navy-900/75 via-navy-900/20 to-transparent" />

      <motion.div style={{ opacity: fade }} className="relative z-20 mx-auto w-full max-w-7xl px-5 pb-24 pt-40 sm:px-8 sm:pb-28">
        <div className="delay-100">
          <Eyebrow>Clew Bay &middot; Wild Atlantic Way &middot; Ireland</Eyebrow>
        </div>

        <h1 className="mt-7 font-serif text-[clamp(3rem,9vw,7.6rem)] font-medium leading-[0.95] tracking-tight text-ivory">
          <MaskedLine delay={0.35}>THE ADVENTURE</MaskedLine>
          <MaskedLine delay={0.5}>
            <em className="font-normal italic text-gold">of a lifetime</em>
          </MaskedLine>
        </h1>

        <motion.p
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.8, ease: EASE }}
          className="mt-8 max-w-xl text-sm font-light leading-relaxed text-ivory/85 sm:text-base"
        >
          Sea safaris, high-speed RIBs, kayaking, SUP and beach saunas on our own private
          island in Clew Bay &mdash; just 12 minutes from Westport town.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.95, ease: EASE }}
          className="mt-10 flex flex-col gap-4 sm:flex-row"
        >
          <GoldButton href="#contact" testId="hero-cta-plan">
            Plan Your Adventure
          </GoldButton>
          <OutlineButton href="#experiences" testId="hero-cta-explore">
            Explore Experiences
          </OutlineButton>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4, duration: 1 }}
        className="absolute bottom-0 left-1/2 z-20 hidden -translate-x-1/2 flex-col items-center gap-3 pb-7 sm:flex"
      >
        <span className="text-[10px] uppercase tracking-[0.34em] text-ivory/60">Scroll</span>
        <motion.span
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2.2, ease: "easeInOut" }}
        >
          <ArrowDown className="h-4 w-4 text-gold" />
        </motion.span>
      </motion.div>
    </section>
  );
}
